
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppProperties from "@/components/sales/SaleEditMobileProperties.vue";
import AppRows from "@/components/sales/SaleEditMobileRows.vue";
import Vue from "vue";
import { FrequencyDocumentEditState } from "../../utils/frequency-document-edit-state";
import AppFinish from "./FrequencyDocumentMobileEditFinish.vue";
import AppFrequencySettingsEdit from "./FrequencySettingsEditMobile.vue";


export default Vue.extend({
	props: {
		state: {
			type: Object as () => FrequencyDocumentEditState,
			required: true
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppFinish,
		AppProperties,
		AppRows,
		AppFrequencySettingsEdit
	}
});
